<template lang="pug">
  div
    .text-right.mb-2
      b-button(variant="primary", size="sm", :disabled="creating", @click="createProperty" ) Agregar propiedad
    .text-center(v-if="loading")
      b-spinner(variant="primary")
    b-card.mb-2(v-for="(property, index) in properties", :key="index")
      b-overlay(:show="updating === property._id", variant="transparent", spinner-variant="primary")
        b-form-row
          b-col(md="12")
            b-form-group(label-size="sm" )
              template(#label)
                .d-flex.justify-content-between.align-items-center
                  label.mb-0 Título
                  trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="destroyProperty(property)" )
              b-form-input(size="sm", placeholder="Nombre", v-model="property.title", @update="updateDebounce(property)")
          b-col(md="6")
            b-form-group(label="Nombre", label-size="sm" )
              b-form-input(size="sm", placeholder="Nombre", v-model="property.key", @update="updateDebounce(property)")
          //b-col(cols="6")
            b-form-group(label="Descripción", label-size="sm" )
              b-form-input(size="sm", placeholder="Descripción", v-model="property.description", @update="updateDebounce(property)")
          b-col(md="6")
            b-form-group(label="Tipo", label-size="sm" )
              b-form-select(size="sm", :options="propertyOptions" v-model="property.type", @change="updateProperty(property)")
          b-col(md="12")
            b-form-group(label="Valores por defecto", label-size="sm" )
              b-form-tags(v-model="property.defaults", placeholder="Agregar valor", size="sm", tag-variant="primary", add-button-text="Agregar", duplicate-tag-text="Valores duplicados", @input="updateProperty(property)" )
    .d-flex.align-items-center(v-if="v_paginationShow")
      b-pagination.mb-0.mr-3( size="sm", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getProperties')", :per-page="v_paginationLimit", :total-rows="v_paginationItemsCount")
      b-spinner(small, variant="primary", v-if="loading")
</template>

<script>
import {createNamespacedHelpers, mapActions} from 'vuex'
import {debounce} from 'lodash'
const propertyController = createNamespacedHelpers('property')

export default {
  name: 'Properties',
  data () {
    return {
      loading: false,
      creating: false,
      updating: false,
      propertyOptions: [
        { value: 'text', text: 'Texto' },
        { value: 'number', text: 'Número' },
        { value: 'date', text: 'Fecha' },
        { value: 'boolean', text: 'Booleano' },
      ]
    }
  },
  computed: {
    ...propertyController.mapState({
      properties: state => state.properties
    })
  },
  methods: {
    ...mapActions([
        'property/all',
        'property/create',
        'property/update',
        'property/destroy',
    ]),
    getProperties () {
      this.loading = true

      this['property/all']({
        account_id: this.$route.params.account_id,
        params: {
          ...this.paginationParamsObject,
        },
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.parsePaginationDataFromResponse(res)
        }
      })
    },
    createProperty() {
      this.creating = true

      this['property/create']({
        account_id: this.$route.params.account_id,
        title: 'Nueva propiedad',
        key: 'nueva',
        type: 'text',
        defaults: [],
        callback: res => {
          this.creating = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    updateDebounce: debounce(function (property) {
      this.updateProperty(property)
    }, 500, {leading: false, trailing: true}),
    updateProperty(property) {
      this.updating = property._id

      this['property/update']({
        ...property,
        callback: res => {
          this.updating = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    destroyProperty(property){
      this.updating = property._id

      this['property/destroy']({
        ...property,
        callback: res => {
          this.updating = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    }
  },
  mounted () {
    this.getProperties()
  }
}
</script>

<style lang="scss" scoped>

</style>